<div class="slider-container">
  <div class="slider-widget">
    <mat-slider 
      [min]="min" 
      [max]="max" 
      [step]="step" 
      [disabled]="disabled"
      [displayWith]="formatLabel"
      discrete
      showTickMarks
      [class.readonly]="readonly"
      class="slider-control">
      <input matSliderThumb [formControl]="control" >
    </mat-slider>
  
    <div class="d-flex justify-content-between">
      <span>{{min}} {{unit}}</span>
  
      <span>{{max}} {{unit}}</span>
    </div>
  </div>
</div>